import React from "react";
import "./project_phase_chip.less";
import { PHASE_NAME_MAPPING } from "@src/constants";

interface ProjectPhaseChipProps {
  projectPhase: string;
  compact?: boolean;
}

const ProjectPhaseChip: React.FC<ProjectPhaseChipProps> = ({
  projectPhase,
  compact = true,
}) => {
  function getPhaseName(projectPhase: string): string {
    return PHASE_NAME_MAPPING[projectPhase] || projectPhase;
  }

  function getPhaseClass(projectPhase: string): string {
    const phaseName = getPhaseName(projectPhase);
    return phaseName?.replace(/\./g, "").toLowerCase();
  }

  return (
    <div
      className={`project-phase-tag-chip ${getPhaseClass(projectPhase)} ${
        compact ? "compact" : "expanded"
      }`}
    >
      {getPhaseName(projectPhase)}
    </div>
  );
};

export default ProjectPhaseChip;
